import { Stack, StackProps } from '@mui/material';
import { FC } from 'react';

export const DrawerWrapper: FC<StackProps> = (props) => (
	<Stack
		direction={'column'}
		gap={2}
		px={3}
		py={2}
		display={'flex'}
		alignItems={'flex-start'}
		width={{ xs: '100vw', sm: '50vw', xl: 700 }}
		{...props}
	/>
);
